import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mockTopics } from '@/mocks/topics';
import { mockCategories } from '@/mocks/categories';
import TopicCard from '@/components/feature/TopicCard';

const TABS = [{ id: 'all', name: '全部' }, ...mockCategories.map((c) => ({ id: c.id, name: c.name }))];

export default function LatestFeed() {
  const [active, setActive] = useState('all');

  const list = active === 'all' ? mockTopics : mockTopics.filter((t) => t.category === active);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-8 md:mb-10">
          <div>
            <p className="text-xs md:text-sm font-medium text-primary-600 tracking-widest mb-2">FEED / 新瓜上桌</p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">最新热议持续更新</h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-2xl">
              每个话题都附有讨论走向与立场分布，点开就能看到网友在争什么、为什么争。
            </p>
          </div>
          <Link
            to="/topics"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
          >
            进入热议广场 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mb-8 flex flex-wrap gap-2">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActive(tab.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                active === tab.id
                  ? 'bg-foreground-900 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>

        {list.length === 0 && (
          <p className="py-16 text-center text-sm text-foreground-500">该分区暂无更新的话题，换个方向看看。</p>
        )}
      </div>
    </section>
  );
}